import EventEmitter from "eventemitter3";
import { DATA_STORE } from "./DataStore";
import { capitalizeString } from "./utils";

const dp = new DOMParser();

let MAX_RESULT;

let values, searchField, searchFieldDefault, resultsContainer, resultsList;

export default class SearchField extends EventEmitter {
  constructor(maxresults = 10) {
    super();
    resultsList = [];
    MAX_RESULT = maxresults;
    values = DATA_STORE.tagsList.concat();

    // container for search
    // this.container = document.querySelector(".price");
    // this.searchWrapper = document.createElement("div");
    // this.searchWrapper.classList.add("search-wrapper");
    // this.container.appendChild(this.searchWrapper);

    // // create search field
    // let html = `<div class="search-wrapper">
    //       <div class="search-form">
    //         <div class="search-field-default">search the collection <span class="material-icons lens">search</span></div>
    //         <input class="search-field" tabindex="0">
    //       </div></div>`;
    // let element = dp.parseFromString(html, "text/html").body.children[0];
    // this.element = element;
    // // document.body.appendChild(element);
    // document.body.insertBefore(element, document.body.firstChild);
    // // this.searchWrapper.appendChild(element);

    this.search_wrapper = document.querySelector(".search-wrapper");

    // hook the search
    searchField = document.querySelector(".search-field");
    searchField.setAttribute("tabindex", 1);
    searchFieldDefault = document.querySelector(".search-field-default");

    searchField.addEventListener("pointerdown", (e) => {
      if (searchField.value.trim() != "") {
        console.warn("searchField.value", searchField.value);
        this.search(searchField.value);
      }
    });
    searchField.addEventListener("keydown", (e) => {
      if (searchField.value.trim() === "") {
        this.clearResults();
      } else {
        searchFieldDefault.classList.add("hidden");
      }

      // jump to first result with arrow down
      if (e.key == "Tab" || e.key == "ArrowDown") {
        if (resultsList.length > 0) resultsList[0].focus();
        e.preventDefault();
        e.target.blur();
      }
    });
    searchField.addEventListener("keyup", (e) => {
      if (searchField.value.trim() === "") {
        this.clearResults();
        return;
      }
      searchFieldDefault.classList.add("hidden");
      this.search(searchField.value);

      // perform a search on all ocr texts
      if (e.key == "Enter") {
        if (searchField.value.trim() == "") return;
        const result = this.searchOCR(searchField.value);

        resultsContainer.classList.add("hidden");
        this.emit("select", searchField.value, result, "search");

        this.clearResults();
        e.preventDefault();
      }
    });
    window.addEventListener("click", (e) => {
      if (e.target != searchField && e.target != resultsContainer) {
        console.log("clear results");
        this.clearResults();
      }
    });

    //   result list
    resultsContainer = document.createElement("div");
    resultsContainer.classList.add("search-result");

    this.search_wrapper.appendChild(resultsContainer);

    //get top position for resultsContainer
    const top = resultsContainer.offsetTop + 40;
    resultsContainer.style.maxHeight = `${window.innerHeight - top}px`;

    // this.searchWrapper.appendChild(resultsContainer);

    // keyboard handling
    resultsContainer.addEventListener("keydown", (e) => {
      if (e.key == "Enter") {
        this.selectResult(e);
        e.preventDefault();
      }
      if (e.key == "ArrowDown" || e.key == "ArrowUp") {
        const el = document.activeElement;
        const tab = el.getAttribute("tabindex");
        let index = resultsList.indexOf(el);

        if (e.key == "ArrowDown") {
          index = (index + 1) % resultsList.length;
        }
        if (e.key == "ArrowUp") {
          // loop on list
          // index = index - 1 < 0 ? resultsList.length - 1 : index - 1;

          // move back to searchfield
          index -= 1;
          if (index < 0) {
            searchField.focus();
            return e.preventDefault();
          }
        }
        resultsList[index].focus();
        e.preventDefault();
      }
    });

    this.clearResults();
  }
  // find ten "best" results
  searchOCR(searchTerm) {
    const regex = new RegExp(`${searchTerm}`, "gi");
    let scores = [];
    DATA_STORE.ocrsList.forEach((str, i) => {
      let count = (str.match(regex) || []).length;
      scores.push({ score: count, id: i, gacid: DATA_STORE.gacLIst[i] });
    });

    scores.sort((a, b) => {
      return a.score - b.score;
    });
    scores.reverse();
    let tmp = [];
    for (let i = 0; i < scores.length; i++) {
      if (scores[i].score <= 0) break;
      tmp.push(scores[i].gacid);
    }
    return tmp;
  }

  // https://stackoverflow.com/questions/43393136/js-create-smart-auto-complete
  search(searchTerm) {
    let inp = sanitize(searchTerm);
    if (inp.length == 0) {
      results.classList.add("hidden");
      return;
    }

    let results = values.filter((s) => fuzzyMatch(s, inp));
    results.sort((a, b) => {
      return getEditDistance(a, inp) - getEditDistance(b, inp);
    });

    resultsList = [];
    results = results.slice(0, MAX_RESULT).map((r) => capitalizeString(r));
    if (results.length == 0) {
      resultsContainer.classList.add("hidden");
      return;
    }
    searchTerm = capitalizeString(searchTerm);
    results = results.map((input, i) => {
      let formatted = "";

      //highlight some characters in the sentence
      if (input.lastIndexOf(searchTerm) == -1) {
        let id = 0;
        for (let i = 0; i < input.length; i++) {
          if (input.charAt(i) == searchTerm.charAt(id)) {
            formatted += `<span class="highlight-letter">${input.charAt(
              i
            )}</span>`;
            id++;
          } else {
            formatted += input.charAt(i);
          }
        }
      } else {
        //highlight the whole sentence
        let id = input.lastIndexOf(searchTerm);
        formatted =
          input.substr(0, id) +
          `<span class="highlight-letter">${input.substr(
            id,
            searchTerm.length
          )}</span>` +
          input.substr(id + searchTerm.length, input.length);
      }
      return formatted;
    });
    return this.updateList(results);
  }

  updateList(res) {
    //clear the list
    while (resultsContainer.children.length) {
      resultsContainer.removeChild(resultsContainer.children[0]);
    }

    // create list of clickable results
    res.forEach((o, i) => {
      const resultItem = this.createResultElement(o);
      resultItem.setAttribute("tabindex", 1 + i);
      resultItem.addEventListener("focusin", (e) => {
        e.target.classList.add("selected");
      });
      resultItem.addEventListener("focusout", (e) => {
        e.target.classList.remove("selected");
      });
      resultItem.addEventListener("click", this.selectResult.bind(this));
      resultsContainer.appendChild(resultItem);
      resultsList.push(resultItem);
    });
    resultsContainer.classList.remove("hidden");
  }

  //result item
  createResultElement(text) {
    const html = `
            <div class="search-result-item">
                <span class="text">${text}</span>
            </div>`;
    return dp.parseFromString(html, "text/html").body.children[0];
  }

  selectResult(e) {
    resultsContainer.classList.add("hidden");
    const resultItem = e.target;
    const tag = resultItem.innerText.trim().toLowerCase();
    searchField.value = tag;
    this.emit("select", tag, DATA_STORE.tags[tag], "tag");
  }

  clearResults() {
    let tmp = [];
    searchFieldDefault.classList.remove("hidden");
    searchField.value = "";
    while (resultsContainer.children.length) {
      tmp.push(resultsContainer.children[0]);
      resultsContainer.removeChild(resultsContainer.children[0]);
    }
    resultsContainer.classList.add("hidden");
    return tmp;
  }
}

// levenshtein distance : https://gist.github.com/andrei-m/982927
/*
Copyright (c) 2011 Andrei Mackenzie
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
// Compute the edit distance between the two given strings
function getEditDistance(a, b) {
  if (a.length == 0) return b.length;
  if (b.length == 0) return a.length;

  var matrix = [];

  // increment along the first column of each row
  var i;
  for (i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  // increment each column in the first row
  var j;
  for (j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for (i = 1; i <= b.length; i++) {
    for (j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) == a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          Math.min(
            matrix[i][j - 1] + 1, // insertion
            matrix[i - 1][j] + 1
          )
        ); // deletion
      }
    }
  }
  return matrix[b.length][a.length] + a.length;
}

// sanitize input text
function sanitize(str) {
  return str
    .trim()
    .toLowerCase()
    .replace(/[^\w\s\']|_/g, "") //alphanumeric only
    .replace(/\s+/g, ""); // no spaces
}

// MAGIC
function fuzzyMatch(s, p) {
  p = p.split("").reduce((a, b) => a + "[^" + b + "]*" + b);
  return RegExp(p, "i").test(s);
}
